import { Badge, Collapse, Flex, Space, Typography } from 'antd'
import { useUserProfile } from 'src/features/user'
import { TStatusPeriod } from 'src/pages/budget/types'
import { useAllUserApprove } from 'src/pages/budget/hook'
import { useBudgetListTeam } from 'src/pages/budget/budgetRequests/hooks'
import { TeamTable } from './components'
import styles from './styles.module.css'

type Props = {
  budgetPeriodName: string | null
  currentPeriodStatus?: TStatusPeriod
}

export const RequestListTeam = ({
  budgetPeriodName,
  currentPeriodStatus,
}: Props) => {
  const { budgetListTeamAll, budgetListTeam, filteredBudgetListTeam } =
    useBudgetListTeam()
  const { allUserApprove } = useAllUserApprove()
  const userProfile = useUserProfile()
  const { Text } = Typography

  if (
    !budgetListTeamAll ||
    !budgetListTeam ||
    !filteredBudgetListTeam ||
    !allUserApprove.includes(userProfile.id)
  )
    return null

  if (budgetListTeam.length === 0) return null

  return (
    <Collapse
      items={[
        {
          key: '1',
          label: (
            <Space>
              <Text strong style={{ fontSize: 28 }}>
                Заявки команды / {budgetPeriodName ?? ''}
              </Text>
              <Badge
                count={filteredBudgetListTeam.length}
                showZero
                color="white"
                style={{ color: 'black', borderRadius: '4px' }}
              />
            </Space>
          ),
          children: (
            <Flex align="center" justify="center" style={{ minHeight: '15em' }}>
              <TeamTable
                list={budgetListTeam}
                filterList={filteredBudgetListTeam}
                currentPeriodStatus={currentPeriodStatus}
              />
            </Flex>
          ),
        },
      ]}
      defaultActiveKey="1"
      className={styles.collapse}
      expandIconPosition="end"
      style={{ backgroundColor: 'var(--color-blue-20)' }}
    />
  )
}
